import ProtectedRoute from '@components/auth/ProtectedRoute';
import AdminLayout from '@components/layout/AdminLayout';
import { lazy } from 'react';
import { AppRoute } from './types';

// Lazy load protected pages
const Dashboard = lazy(() => import('@pages/Dashboard'));
const Profile = lazy(() => import('@pages/Profile'));
const Users = lazy(() => import('@pages/Users'));
const SponsorInvoices = lazy(() => import('@pages/SponsorInvoices'));
const Reports = lazy(() => import('@pages/Reports'));
const Categories = lazy(() => import('@pages/Categories'));
const BusinessCategories = lazy(() => import('@pages/BusinessCategories'));
const Groups = lazy(() => import('@pages/Groups'));
const Polls = lazy(() => import('@pages/Polls'));
const Surveys = lazy(() => import('@pages/Surveys'));
const Events = lazy(() => import('@pages/Events'));
const News = lazy(() => import('@pages/News'));
const Announcements = lazy(() => import('@pages/Announcements'));
const Plans = lazy(() => import('@pages/Plans'));
const PlanFeatures = lazy(() => import('@pages/PlanFeatures'));
const Roles = lazy(() => import('@pages/Roles'));
const HelpFaqs = lazy(() => import('@pages/HelpFaqs'));
const CmsEditorPage = lazy(() => import('@pages/CmsEditorPage'));
// Helper function to wrap routes with ProtectedRoute and AdminLayout
const createProtectedRoute = (element: React.ReactNode) => (
  <ProtectedRoute>
    <AdminLayout>{element}</AdminLayout>
  </ProtectedRoute>
);

export const protectedRoutes: AppRoute[] = [
  {
    path: '/dashboard',
    element: createProtectedRoute(<Dashboard />),
    title: 'Dashboard',
    showInNav: true,
  },
  {
    path: '/users',
    element: createProtectedRoute(<Users />),
    title: 'Users',
    showInNav: true,
    permissions: ['admin', 'user.read'],
  },
  {
    path: '/invoices/:sponsorId',
    element: createProtectedRoute(<SponsorInvoices />),
    title: 'Sponsor Invoices',
    showInNav: false,
    permissions: ['admin', 'user.read'],
  },
  {
    path: '/sponsors/:sponsorId/invoices',
    element: createProtectedRoute(<SponsorInvoices />),
    title: 'Sponsor Invoices',
    showInNav: false,
    permissions: ['admin', 'user.read'],
  },
  {
    path: '/reports',
    element: createProtectedRoute(<Reports />),
    title: 'Reports',
    showInNav: true,
  },
  {
    path: '/categories',
    element: createProtectedRoute(<Categories />),
    title: 'Categories',
    showInNav: true,
  },
  {
    path: '/business/categories',
    element: createProtectedRoute(<BusinessCategories />),
    title: 'Business Categories',
    showInNav: true,
  },
  {
    path: '/groups',
    element: createProtectedRoute(<Groups />),
    title: 'Groups',
    showInNav: true,
  },
  {
    path: '/polls',
    element: createProtectedRoute(<Polls />),
    title: 'Polls',
    showInNav: true,
  },
  {
    path: '/surveys',
    element: createProtectedRoute(<Surveys />),
    title: 'Surveys',
    showInNav: true,
  },
  {
    path: '/events',
    element: createProtectedRoute(<Events />),
    title: 'Events',
    showInNav: true,
  },
  {
    path: '/news',
    element: createProtectedRoute(<News />),
    title: 'News',
    showInNav: true,
  },
  {
    path: '/announcements',
    element: createProtectedRoute(<Announcements />),
    title: 'Announcements',
    showInNav: true,
  },
  {
    path: '/plans',
    element: createProtectedRoute(<Plans />),
    title: 'Plans',
    showInNav: true,
  },
  {
    path: '/plan-features',
    element: createProtectedRoute(<PlanFeatures />),
    title: 'Plan Features',
    showInNav: true,
  },
  {
    path: '/roles',
    element: createProtectedRoute(<Roles />),
    title: 'Roles & Permissions',
    showInNav: true,
  },
  {
    path: '/help-faqs',
    element: createProtectedRoute(<HelpFaqs />),
    title: 'Help & FAQ',
    showInNav: true,
  },
  {
    path: '/terms-and-conditions',
    element: createProtectedRoute(
      <CmsEditorPage slug="terms-and-conditions" pageTitle="Terms & Conditions" />
    ),
    title: 'Terms & Conditions',
    showInNav: true,
  },
  {
    path: '/privacy-policy',
    element: createProtectedRoute(
      <CmsEditorPage slug="privacy-policy" pageTitle="Privacy Policy" />
    ),
    title: 'Privacy Policy',
    showInNav: true,
  },
  {
    path: '/profile',
    element: createProtectedRoute(<Profile />),
    title: 'Profile',
    showInNav: false,
  },
];
